<template>
  <div>
    <v-card class="ma-2 pa-1">
      <v-card-title>Welcome! Here are your tasks</v-card-title>
      <v-dialog persistent v-model="dialog" max-width="70%">
        <template v-slot:activator="{ on }">
          <v-btn color="primary" v-on="on" text>
            Add Task
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title>Add Task</v-card-title>
          <v-card-text>
            <v-form ref="form">
              <v-text-field v-model="title" label="Title"/>
              <v-textarea v-model="notes" label="Notes"/>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeDialog">Close</v-btn>
            <v-btn text @click="add">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn text @click="reset" color="blue">Reset Tasks</v-btn>
    </v-card>
    <UnCompleted/>
    <Completed/>
  </div>
</template>

<script>
  import Completed from "./views/Completed";
  import UnCompleted from "./views/UnCompleted";
  import { mapMutations } from 'vuex';
  import {TaskObj} from "../Constructs";

export default {
  name: "Home",
  components: {
    Completed,
    UnCompleted,
  },
  data() {
    return {
      dialog: false,
      title: "",
      notes: ""
    }
  },
  methods: {
    ...mapMutations(["addTask", 'reset']),
    add() {
      this.addTask(new TaskObj(this.title, this.notes));
      this.closeDialog();
    },
    closeDialog() {
      this.dialog = false;
      this.title = "";
      this.notes = "";
    }
  }
};
</script>

<style>
</style>